import "./home.css";

export default function WhoWeAre() {
  return (
    <section className="gps-who">
      <div className="gps-who-inner">
        <div className="gps-who-visual">
          <img
            src="/images/financial-pyramid0000.png"
            alt="Financial planning pyramid — Investment, Savings, and Protection"
          />
        </div>

        <div className="gps-who-content">
          <p className="gps-who-eyebrow">WHO WE ARE</p>
          <h2 className="gps-who-title">About GPS Finvest</h2>
          <h3 className="gps-who-subtitle">
            Your Trusted Partner in Wealth Creation
          </h3>

          <div className="gps-who-body">
            <p>
              Founded in 2024, GPS Finvest was created with a clear vision — to
              make smart investing simple, accessible, and effective for
              everyone.
            </p>
            <p>
              With over 15 years of combined expertise in financial services, we
              provide personalized investment planning across mutual funds,
              SIPs, bonds, loans, and retirement planning.
            </p>
            <p>
              Our transparent approach and goal-based strategies have helped
              thousands of investors build secure and prosperous futures.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
